import Vue from "vue";
import CurrencyAmount from "@/components/CurrencyAmount/index";
import InfoPopover from "@/components/InfoPopover/index";
import PrefixPhone from "@/components/PrefixPhone/index";
import TableUpload from "@/components/TableUpload/index";
import CheckboxGroupWithOther from "@/components/CheckboxGroupWithOther/index";

// 组件清单
const components = {
  CurrencyAmount,
  InfoPopover,
  PrefixPhone,
  TableUpload,
  CheckboxGroupWithOther,
};

// 遍历并全局注册
Object.keys(components).forEach(key => {
  Vue.component(key, components[key]);
});

export default components;
